function initEmbla(emblaNode, emblaOptions, emblaPlugins) {
	
	/* maybe use this if we have issues with emblaPlugins undefined:
	const carousel = EmblaCarousel(
			emblaNode,
			emblaOptions,
			...(emblaPlugins ? [emblaPlugins] : []) // Spread plugins array only if defined
	);
	*/
	const carousel = EmblaCarousel(
		emblaNode,
		emblaOptions,
		emblaPlugins
	);
	
	const
		emblaPrevButton = emblaNode.querySelector('.embla__prev'),
		emblaNextButton = emblaNode.querySelector('.embla__next'),
		emblaPagination = emblaNode.querySelectorAll('.carousel-pagination');
	
	function logSlidesInView() {
		//console.log( carousel );
		const selectedIndex = carousel.selectedScrollSnap();	
		
		if (emblaPagination) {
			emblaPagination.forEach(pagination => {
				pagination.classList.remove('active');
			});
		
			const paginationActive = emblaPagination[selectedIndex];
			if ( paginationActive ) {
				paginationActive.classList.add('active');
			}
		}
		
		if (emblaNextButton && emblaOptions.loop == false) {
			const lastIndex = carousel.scrollSnapList().length - 2; // Exclude first and last
			
			if ( selectedIndex >= lastIndex) {
				emblaNextButton.setAttribute('disabled', 'true');
			} else {
				emblaNextButton.removeAttribute('disabled');
			}
			
			if ( selectedIndex == 0) {
				emblaPrevButton.setAttribute('disabled', 'true');
			} else {
				if (emblaPrevButton) {
					emblaPrevButton.removeAttribute('disabled');
				}
			}
		}
		
		//Only show slides if they are in view
		if ( emblaOptions.showInView == true) {
			const slidesInView = carousel.slidesInView();
			const slides = emblaNode.querySelectorAll('.block');
			
			if ( slidesInView.length != 0 ) {
				slides.forEach((slide, index) => {
					if (slidesInView.includes(index)) {
						slide.classList.remove('hide-slide');
					} else {
						slide.classList.add('hide-slide');
					}
				});
			}
		}
	}
	
	carousel.on('select', () => {
		logSlidesInView();
	});
	
	// Add event listeners for navigation buttons
	if (emblaNextButton) {
		emblaNextButton.addEventListener('click', carousel.scrollNext, false);
		
		//Enable/Disable nav on load
		if (carousel.scrollSnapList().length < 2) {
			emblaNextButton.setAttribute('disabled', 'true');
		}
	}
	if (emblaPrevButton) {
		emblaPrevButton.addEventListener('click', carousel.scrollPrev, false);
	}

	
	// Add event listeners for navigation pagination
	if (emblaPagination) {
		emblaPagination.forEach((pagination) => {
			pagination.addEventListener('click', (event) => {
				const slideIndex = parseInt(pagination.getAttribute('data-slide'), 10);
				//console.log(slideIndex);
				if (!isNaN(slideIndex)) {
						carousel.scrollTo(slideIndex); // Scroll to the slide index
				}
			});
		});
	}
} 
window.initEmbla = initEmbla;
